// extracted by mini-css-extract-plugin
module.exports = {"form":"NewsletterForm_form__g5hQh","input":"NewsletterForm_input___DLG6","error":"NewsletterForm_error__kFt5i"};